import React, { useContext, useState } from "react";
import FormDataContext from "integrations/contexts/FormDataContext";
import { SymantecSES } from "@graylog/enterprise-api";
import { renderOptions } from "../common/Options";
import FormWrap from "../common/FormWrap";
import formValidation from "../common/utils/formValidation";
import ValidatedInput from "../common/ValidatedInput";
const StepAuthorize = ({ onSubmit, onChange }) => {
  const { formData } = useContext(FormDataContext);
  const [formError, setFormError] = useState(null);
  const region = [
    { label: "North America (us)", value: "https://api.sep.securitycloud.symantec.com" },
    { label: "Europe (eu)", value: "https://api.sep.eu.securitycloud.symantec.com" },
    { label: "India (in)", value: "https://api.sep.in.securitycloud.symantec.com" }
  ];
  const { connectionString } = formData;
  const [formValidated, setFormValidated] = useState("");
  const fieldChange = (event) => {
    if (event) {
      setFormValidated(event.target.value);
    }
    onChange(event, null);
  };
  const [loading, setLoading] = useState(false);
  const handleSubmit = () => {
    var _a, _b;
    setLoading(true);
    const fetcher = SymantecSES.checkCredentials({
      oauth_credentials: ((_a = formData == null ? void 0 : formData.oauthCredentials) == null ? void 0 : _a.value) || "",
      ses_base_url: ((_b = formData == null ? void 0 : formData.sesBaseURL) == null ? void 0 : _b.value) || ""
    });
    fetcher.then((result) => {
      if (result.result === "valid") {
        setFormError(null);
        onSubmit();
      } else {
        setFormError({
          full_message: result.result,
          nice_message: "Unable to connect to Symantec SES using provided configuration."
        });
      }
      setLoading(false);
    }).catch((err) => {
      setLoading(false);
      setFormError({
        full_message: err.message,
        nice_message: "Unable to connect to Symantec SES using provided configuration."
      });
    });
  };
  const isFormValid = formValidation.isFormValid(["symantecSESName", "oauthCredentials", "sesBaseURL"], formData);
  return /* @__PURE__ */ React.createElement(
    FormWrap,
    {
      onSubmit: handleSubmit,
      buttonContent: "Verify Connection & Proceed",
      disabled: isFormValid,
      loading,
      title: "",
      error: formError,
      description: ""
    },
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        className: "",
        id: "symantecSESName",
        type: "text",
        fieldData: formData.symantecSESName,
        onChange,
        placeholder: "Input Name",
        label: "Input Name",
        autoComplete: "off",
        help: "Select a name of your new input that describes it.",
        defaultValue: connectionString == null ? void 0 : connectionString.value,
        required: true
      }
    ),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        className: "",
        id: "oauthCredentials",
        type: "password",
        onChange,
        fieldData: formData.oauthCredentials,
        label: "OAuth Credentials",
        help: "The OAuth Credential of your client application.",
        required: true
      }
    ),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        type: "select",
        id: "sesBaseURL",
        onChange: (e) => fieldChange(e),
        fieldData: formData.sesBaseURL,
        help: "Symantec SES Hosting location.",
        required: true,
        label: "Hosting Location"
      },
      renderOptions(region, "Choose your account Location", false)
    ),
    /* @__PURE__ */ React.createElement("p", null, formValidated && `Your Cloud Base Url: ${formValidated}`)
  );
};
export default StepAuthorize;
